import React from "react";
import { Stepper, StepButton, Step, Button } from "@mui/material";
import ResponsiblePerson from "../../components/administration/AddBooking/ResponsiblePerson";
import Payment from "../../components/administration/AddBooking/Payment";
import Member from "../../components/administration/AddBooking/Member";
import RestUtilities, { IRestResponse } from "../../services/RestUtilities";
import Users from "../../models/Users";
import Bookings from "../../models/Bookings";
import MemberGenderTypes from "../../models/MemberGenderTypes";
import EventAdditionalPriceDefinitions from "../../models/EventAdditionalPriceDefinitions";
import EventPriceDefinitions from "../../models/EventPriceDefinitions";
import BookingMember from "../../models/BookingMembers";
import EventModel from "../../models/Events";
import BookingMemberToEventPriceDefinition from "../../models/BookingMemberToEventPriceDefinition";
import BookingMemberToEventAdditionalPriceDefinition from "../../models/BookingMemberToEventAdditionalPriceDefinition";
import BookingTeams from "../../models/BookingTeams";
import { RoutePaths } from "../../components/Routes";
import PaymentTypes from "../../models/PaymentTypes";
import AuthStore from "../../stores/Auth";
import UserRolesModel, { UserRoles } from "../../models/UserRoles";
import { EventOptionAvailabilityTypesEnum } from "../../models/EventOptionAvailabilityTypes";
import UserGroups from "../../models/UserGroups";
import { GrowMessage } from "../../components/GrowMessage";
import { withRouter } from "../../components/Shared/withNavigate";
import { bool } from "prop-types";

export class BookingMemberRequiredFieldsValid {
  [key: string]: any;
  firstName: boolean = true;
  lastName: boolean = true;
  memberAgeGroupId: boolean = true;
  memberGroupTypeId: boolean = true;
  eventOptionId: boolean = true;
}

export class AddBooking extends React.Component<any, any> {
  public static FirstStep: string = "Allgemein";
  public static SecondStep: string = "Zahlung";
  public static ThirdStep: string = "Teilnehmer";

  public static SubmitMode: string = "Submit";
  public static EditMode: string = "Edit";

  eventId: number = 0;
  bookingId: number = 0;

  constructor(props: any) {
    super(props);

    const params = new URLSearchParams(this.props.router.location.search);
    const eventId = params.get("eventId");
    const bookingId = params.get("bookingId");

    if (typeof eventId != "undefined" && eventId != null) {
      this.eventId = parseInt(eventId);
      this.fetchEvent(this.eventId);
    }

    if (typeof bookingId !== "undefined" && bookingId != null) {
      this.fetchBooking(parseInt(bookingId));
    }
  }

  state = {
    event: new EventModel(),
    activeStep: 0,
    showAddBookingMemberModal: false,
    showAddTeamBookingMemberModal: false,
    showAddTeamModal: false,
    personalNumbers: [] as string[],
    genderTypes: [] as MemberGenderTypes[],
    options: [] as EventAdditionalPriceDefinitions[],
    priceDefinitions: [] as EventPriceDefinitions[],
    responsiblePerson: new Users(),
    booking: new Bookings(),
    bookingMember: new BookingMember(),
    bookingMembersList: [] as BookingMember[],
    selectedOptions: [] as EventAdditionalPriceDefinitions[],
    modeMember: "Submit",
    bookingTeams: [] as BookingTeams[],
    newTeam: new BookingTeams(),
    modeTeam: "Submit",
    paymentTypes: [] as PaymentTypes[],
    showError: false,
    errorMessage: "",
    bookingMemberRequiredFieldsValid: new BookingMemberRequiredFieldsValid(),
    disableSaveButton: false,
    showEditUserModal: false,
    userToEdit: new Users(),
    userRoles: [] as UserRolesModel[],
    userGroups: [] as UserGroups[],
    IsTeamAvailable: false,
    IsSingleAvailable: false,
    IsTeamPlayerAvailable: false,
  };

  getSteps = () => {
    return [AddBooking.FirstStep, AddBooking.SecondStep, AddBooking.ThirdStep];
  };

  getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <ResponsiblePerson
            // personalNumbers={this.state.personalNumbers}
            handleChangePerson={this.handleChangeResponsiblePerson}
            user={this.state.responsiblePerson}
            fetch={this.fetchPersonalNumbers}
            showEditUserModal={this.state.showEditUserModal}
            handleShowEditUserModal={this.handleShowEditUserModal}
            handleHideEditUserModal={this.handleHideEditUserModal}
            editUser={this.editUser}
            userToEdit={this.state.userToEdit}
            handleEditChange={this.handleEditChange}
            userRoles={this.state.userRoles}
            userGroups={this.state.userGroups}
          ></ResponsiblePerson>
        );
      case 1:
        return (
          <Payment
            personalNr={this.state.responsiblePerson.personalNr}
            fetchPaymentTypes={this.fetchPaymentTypes}
            paymentTypes={this.state.paymentTypes}
            paymentTypeId={this.state.booking.paymentTypeId}
            change={this.changePaymentType}
            isAdmin={true}
          ></Payment>
        );
      case 2:
        return (
          <Member
            teamBookingMemberModal={this.state.showAddTeamBookingMemberModal}
            bookingMemberModal={this.state.showAddBookingMemberModal}
            teamModal={this.state.showAddTeamModal}
            IsSingleAvailable={this.state.IsSingleAvailable}
            IsTeamPlayerAvailable={this.state.IsTeamPlayerAvailable}
            IsTeamAvailable={this.state.IsTeamAvailable}
            hideModal={this.hideModal}
            showAddBookingMemberModal={this.showAddBookingMemberModal}
            showAddTeamBookingMemberModal={this.showAddTeamBookingMemberModal}
            showAddTeamModal={this.showAddTeamModal}
            fetchGenderTypes={this.fetchMemberGenderTypes}
            genderTypes={this.state.genderTypes}
            fetchOptions={this.fetchEventAdditionalPriceDefinitions}
            options={this.state.options}
            fetchPrices={this.fetchEventPriceDefinitions}
            prices={this.state.priceDefinitions}
            changeMember={this.handleChangeBookingMember}
            bookingMember={this.state.bookingMember}
            addOption={this.handleAddOptionToMember}
            submit={this.submitBookingMember}
            bookingMembersList={this.state.bookingMembersList}
            fetchBookingMembersList={this.fetchBookingMembers}
            selectedOptions={this.state.selectedOptions}
            delete={this.deleteBookingMember}
            changeMode={this.handleChangeMode}
            changeBookingMember={this.handleChangeCurrentBookingMember}
            fetchTeams={this.fetchBookingTeams}
            bookingTeams={this.state.bookingTeams}
            changeNewTeam={this.handleChangeTeam}
            newTeam={this.state.newTeam}
            submitNewTeam={this.submitNewTeam}
            booking={this.state.booking}
            changeBooking={this.handleChangeBooking}
            changeTeamMode={this.handleChangeTeamMode}
            changeCurrentTeam={this.handleChangeCurrentTeam}
            validFields={this.state.bookingMemberRequiredFieldsValid}
            isAdmin={true}
            eventObject={this.state.event}
            deleteTeam={this.deleteTeam}
            disableSaveButton={this.state.disableSaveButton}
            switchSaveButton={this.switchSaveButton}
            resetSelectedOptions={this.resetSelectedOptions}
          ></Member>
        );
      default:
        return <></>;
    }
  };

  handleNext = (): void => {
    const { activeStep } = this.state;

    if (activeStep === 0) {
      if (this.state.booking.id > 0) {
        this.editBooking().then(() => {
          this.setState({ activeStep: activeStep + 1 });
        });
      } else {
        this.submitBooking().then((data) => {
          if (data) this.setState({ activeStep: activeStep + 1 });
        });
      }
    } else if (activeStep === 1) {
      this.editBooking().then(() => {
        this.setState({ activeStep: activeStep + 1 });
      });
    } else if (activeStep === 2) {
      if (!this.state.booking.isValid) {
        this.showError({ error_content: "Die Anmeldung ist nicht gültig" });
        return;
      }

      this.editBooking(true).then(() => {
        this.props.router.navigate(
          `${RoutePaths.EditEvent}?eventid=${this.eventId}&step=3`
        );
      });
    }
  };

  switchSaveButton = (disable: boolean) => {
    if (disable !== this.state.disableSaveButton)
      this.setState((state: any) => ({
        disableSaveButton: disable,
      }));
  };

  handleBack = (): void => {
    const { activeStep } = this.state;
    this.setState({ activeStep: activeStep - 1 });
  };

  handleStep = (index: number): void => {
    this.setState({ activeStep: index });
  };

  showAddBookingMemberModal = (member: BookingMember): void => {
    this.setState({ showAddBookingMemberModal: true }, () =>
      this.handleChangeCurrentBookingMember(member)
    );
  };

  checkIsTeamAvailable = () => {
    RestUtilities.get<any>(
      `/api/BookingMembers/IsTeamAvailable?eventId=${this.eventId}`
    )
      .then((resp) => {
        this.setState({ IsTeamAvailable: true });
      })
      .catch((err) => {
        this.setState({ IsTeamAvailable: false });
      });
  };

  checkIsSingleAvailable = () => {
    RestUtilities.get<any>(
      `/api/BookingMembers/IsSingleAvailable?eventId=${this.eventId}`
    )
      .then((resp) => {
        this.setState({ IsSingleAvailable: true });
      })
      .catch((err) => {
        this.setState({ IsSingleAvailable: false });
      });
  };

  checkIsTeamPlayerAvailable = () => {
    RestUtilities.get<any>(
      `/api/BookingMembers/IsTeamPlayerAvailable?eventId=${this.eventId}`
    )
      .then((resp) => {
        this.setState({ IsTeamPlayerAvailable: true });
      })
      .catch((err) => {
        this.setState({ IsTeamPlayerAvailable: false });
      });
  };

  showAddTeamBookingMemberModal = (member: BookingMember): void => {
    if (this.state.bookingTeams.length === 0) {
      this.showAddTeamModal();
      return;
    }

    this.setState({ showAddTeamBookingMemberModal: true }, () =>
      this.handleChangeCurrentBookingMember(member)
    );
  };

  showAddTeamModal = (): void => {
    this.setState({ showAddTeamModal: true });
  };

  hideModal = (): void => {
    const requiredFields = {
      ...Object.keys(this.state.bookingMemberRequiredFieldsValid).reduce(
        (reduced, key) => ({ ...reduced, [key]: true }),
        {}
      ),
    };

    this.setState({
      showAddBookingMemberModal: false,
      showAddTeamBookingMemberModal: false,
      showAddTeamModal: false,
      bookingMember: new BookingMember(),
      newTeam: new BookingTeams(),
      bookingMemberRequiredFieldsValid: requiredFields,
    });
  };

  handleChangeMode = (mode: string): void => {
    this.setState({ modeMember: mode });
  };

  handleChangeTeamMode = (mode: string): void => {
    this.setState({ modeTeam: mode });
  };

  handleChangeCurrentBookingMember = (member: BookingMember) => {
    const { options } = this.state;
    const selectedOptions =
      member.tblBookingMemberToEventAdditionalPriceDefinition.map((x) => {
        return options.filter(
          (y) => y.id === x.eventAdditionalPriceDefinitionId
        )[0];
      });

    const isTeamMember =
      this.state.showAddTeamBookingMemberModal === true
        ? EventOptionAvailabilityTypesEnum.Team
        : EventOptionAvailabilityTypesEnum.Einzel;
    this.fetchEventPriceDefinitions(
      member.memberAgeGroupId,
      member.memberGroupTypeId,
      member.eventOptionId,
      isTeamMember
    ).then(() => {
      this.setState({
        bookingMember: member,
        selectedOptions: selectedOptions,
      });
    });
  };

  handleChangeTeam = (event: any): void => {
    const newTeam = { ...this.state.newTeam };
    const fieldName = event.target.name;

    newTeam[fieldName] = event.target.value;

    this.setState({ newTeam: newTeam });
  };

  handleChangeCurrentTeam = (team: BookingTeams): void => {
    this.setState({ newTeam: team });
  };

  handleChangeBooking = (event: any): void => {
    const newBooking: any = { ...this.state.booking };
    const fieldName = event.target.name;

    newBooking[fieldName] = event.target.value;

    this.setState({ booking: newBooking });
  };

  fetchBooking = (bookingId: number): void => {
    RestUtilities.get<Bookings>(`/api/Bookings?bookingId=${bookingId}`)
      .then((resp) => {
        this.setState({ booking: resp.content });
        this.fetchUser(resp.content.bookingResponsibleUserId);
        this.checkIsSingleAvailable();
        this.checkIsTeamAvailable();
        this.checkIsTeamPlayerAvailable();
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchEvent = (id: number): void => {
    RestUtilities.get<EventModel>(`/api/Events?eventId=${id}`).then((resp) => {
      const requiredFields = { ...this.state.bookingMemberRequiredFieldsValid };
      if (resp.content.memberGenderTypeRequired) {
        requiredFields["gender"] = true;
      }
      if (resp.content.memberBirthDateRequired)
        requiredFields["birthday"] = true;

      this.setState({
        event: resp.content,
        bookingMemberRequiredFieldsValid: requiredFields,
      });
    });
  };

  fetchUser = (id: number) => {
    RestUtilities.get<Users>(`/api/Users?id=${id}`)
      .then((resp) => {
        this.setState({ responsiblePerson: resp.content });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchPersonalNumbers = async (e: any) => {
    let url = "";
    if (e) url = `/api/Users/GetPersonalNumbers?term=${e}`;
    else url = "/api/Users/GetPersonalNumbers";

    let result = await RestUtilities.get<any[]>(url);

    return result.content;
    // .then(resp => {
    //   return resp.content
    // })
    // .catch(resp => {
    //   this.showError(resp)
    // })
  };

  fetchMemberGenderTypes = (): void => {
    RestUtilities.get<MemberGenderTypes[]>("/api/MemberGenderTypes")
      .then((resp) => {
        this.setState({ genderTypes: resp.content });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchEventPriceDefinitions = (
    ageGroupId: number = null,
    memberGroupId: number = null,
    eventOptionId: number = null,
    availabilityTypeId: number = null
  ): Promise<void> => {
    let url = `/api/EventPriceDefinitions?eventId=${this.eventId}`;

    if (ageGroupId !== null) {
      url += `&ageGroupId=${ageGroupId}`;
    }

    if (memberGroupId !== null) {
      url += `&memberGroupId=${memberGroupId}`;
    }

    if (eventOptionId !== null) {
      url += `&eventOptionId=${eventOptionId}`;
    }

    if (availabilityTypeId !== null)
      url += `&availabilityTypeId=${availabilityTypeId}`;

    return RestUtilities.get<EventPriceDefinitions[]>(url)
      .then((resp) => {
        this.setState({ priceDefinitions: resp.content });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchEventAdditionalPriceDefinitions = (
    ageGroupId: number = null,
    memberGroupId: number = null
  ): void => {
    let url = `/api/EventAdditionalPriceDefinitions?eventId=${this.eventId}`;

    if (ageGroupId !== null) {
      url += `&ageGroupId=${ageGroupId}`;
    }

    if (memberGroupId !== null) {
      url += `&memberGroupId=${memberGroupId}`;
    }

    RestUtilities.get<EventAdditionalPriceDefinitions[]>(url)
      .then((resp) => {
        this.setState({ options: resp.content });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchBookingMembers = (): Promise<void> => {
    const bookingId = this.state.booking.id;
    return RestUtilities.get<BookingMember[]>(
      `/api/BookingMembers?bookingId=${bookingId}`
    )
      .then((resp) => {
        this.setState({ bookingMembersList: resp.content });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchBookingTeams = (): Promise<void> => {
    const bookingId = this.state.booking.id;

    return RestUtilities.get<BookingTeams[]>(
      `/api/BookingTeams?bookingid=${bookingId}`
    )
      .then((resp) => {
        this.setState({ bookingTeams: resp.content });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchPaymentTypes = (personalNr: string = ""): void => {
    RestUtilities.get<PaymentTypes[]>(
      `/api/PaymentTypes?personalNr=${personalNr}`
    )
      .then((resp) => {
        let response = resp.content;
        if (
          AuthStore.getRole() === UserRoles[UserRoles.Benutzer] ||
          AuthStore.getRole() === UserRoles[UserRoles.Veranstalter]
        ) {
          let barBLIndex = response.findIndex((x) => x.id === 4);
          let barBGIndex = response.findIndex((x) => x.id === 3);
          response.splice(barBLIndex, 1);
          response.splice(barBGIndex, 1);
        }
        this.setState({ paymentTypes: response });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchUserRoles = () => {
    RestUtilities.get<UserRolesModel[]>("/api/UserRoles")
      .then((resp) => {
        let userRoles = resp.content as UserRolesModel[];
        this.setState({ userRoles: userRoles });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchUserGroups = () => {
    RestUtilities.get<UserGroups[]>("/api/UserGroups")
      .then((resp) => {
        let userGroups = resp.content as UserGroups[];
        this.setState({ userGroups: userGroups });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  handleChangeResponsiblePerson = (event: any): void => {
    let personalNumber = event.target.value;
    if (personalNumber) {
      RestUtilities.get<Users[]>(`/api/Users?personalNr=${personalNumber}`)
        .then((resp) => {
          let user = resp.content[0] as Users;
          let booking = { ...this.state.booking };
          booking.bookingResponsibleUserId = user.id;
          this.setState({
            responsiblePerson: resp.content[0],
            userToEdit: resp.content[0],
            booking: booking,
          });
        })
        .catch((resp) => {
          this.showError(resp);
        });
    } else {
      this.setState({ responsiblePerson: "", userToEdit: "" });
    }
  };

  handleChangeBookingMember = (event: any): void => {
    const targetValue = event.target.value;
    const targetName = event.target.name;
    this.setState((prevState: any, props: any) => {
      let name = targetName;
      const newModel = { ...prevState.bookingMember };

      newModel[name] = targetValue;

      this.validateBookingMember(newModel);

      return { bookingMember: newModel };
    });
  };

  handleAddOptionToMember = (event: any): void => {
    const optionId = event.target.value;
    const optionTypeName = event.target.name;
    const { selectedOptions } = this.state;

    if (optionId === "") {
      let isPriceOfTypePresent =
        this.state.selectedOptions.filter(
          (x) => x.eventAdditionalPriceTypeName === optionTypeName
        ).length > 0;

      if (isPriceOfTypePresent) {
        const index = selectedOptions.findIndex(
          (x) => x.eventAdditionalPriceTypeName === optionTypeName
        );
        selectedOptions.splice(index, 1);
      }
      this.setState({ selectedOptions: selectedOptions });
      return;
    }

    const optionToAdd = this.state.options.filter((x) => x.id === optionId)[0];
    const optionType = optionToAdd.eventAdditionalPriceTypeId;

    let isPriceOfTypePresent =
      selectedOptions.filter((x) => x.eventAdditionalPriceTypeId === optionType)
        .length > 0;

    if (isPriceOfTypePresent) {
      const index = selectedOptions.findIndex(
        (x) => x.eventAdditionalPriceTypeId === optionType
      );
      selectedOptions.splice(index, 1);
    }
    selectedOptions.push(optionToAdd);

    this.setState({ selectedOptions: selectedOptions });
  };

  changePaymentType = (event: any): void => {
    const newBooking = { ...this.state.booking };

    const typeId = event.target.value;

    newBooking.paymentTypeId = parseInt(typeId);

    this.setState({ booking: newBooking });
  };

  submitBooking = (): Promise<any> => {
    const booking = { ...this.state.booking };

    if (
      booking.bookingResponsibleUserId == 0 ||
      booking.bookingResponsibleUserId === undefined
    )
      return Promise.resolve(null);

    booking.eventId = this.eventId;

    if (booking.paymentTypeId == undefined) booking.paymentTypeId = 3;

    return RestUtilities.post<Bookings>("/api/Bookings/Submit", booking)
      .then((resp) => {
        this.setState({ booking: resp.content });
        return Promise.resolve(booking);
      })
      .catch((resp) => {
        this.showError(resp);
        throw resp.error_content;
      });
  };

  editBooking = (isFinished: boolean = false): Promise<any> => {
    const booking = { ...this.state.booking };
    booking.eventId = this.eventId;

    return RestUtilities.put<Bookings>(
      `/api/Bookings/Edit?isFinished=${isFinished}`,
      booking
    )
      .then((resp) => {
        this.setState({ booking: resp.content });
      })
      .catch((resp) => {
        this.showError(resp);
        throw resp.error_content;
      });
  };

  submitBookingMember = (): void => {
    const bookingMember = { ...this.state.bookingMember };
    const event = { ...this.state.event };
    bookingMember.bookingId = this.state.booking.id;

    bookingMember.tblBookingMemberToEventPriceDefinition =
      this.state.priceDefinitions.map((x) => {
        let memberToPrice = new BookingMemberToEventPriceDefinition();
        memberToPrice.eventPriceDefinitionId = x.id;
        return memberToPrice;
      });

    bookingMember.tblBookingMemberToEventAdditionalPriceDefinition =
      this.state.selectedOptions.map((x) => {
        let memberToAdditionalPrice =
          new BookingMemberToEventAdditionalPriceDefinition();
        memberToAdditionalPrice.bookingMemberId = this.state.bookingMember.id;
        memberToAdditionalPrice.eventAdditionalPriceDefinitionId = x.id;
        return memberToAdditionalPrice;
      });

    if (
      typeof bookingMember.teamId == "undefined" ||
      event.singleTeamPrice === null ||
      event.singleTeamPrice === 0
    )
      bookingMember.overallPrice += this.state.priceDefinitions.reduce(
        (sum, x) => sum + x.priceValue,
        0
      );

    bookingMember.overallPrice += this.state.selectedOptions.reduce(
      (sum, x) => sum + x.priceValue,
      0
    );

    if (!this.validateBookingMember(bookingMember)) return;

    const birthday = bookingMember.birthday;
    if (
      birthday !== undefined &&
      birthday !== null &&
      typeof birthday != "string"
    )
      bookingMember.birthday.setHours(22); //so that it does not go to previous day after subtracting time difference

    if (this.state.modeMember === AddBooking.SubmitMode) {
      RestUtilities.post<BookingMember>(
        "/api/BookingMembers/Submit",
        bookingMember
      )
        .then((resp) => {
          this.fetchBookingMembers().then(() => {
            const isTeamValid =
              this.state.event.maxTeamSize ===
              this.state.bookingMembersList.filter(
                (x) => x.teamId === resp.content.teamId
              ).length;
            if (resp.content.teamId !== null && !isTeamValid) {
            } else {
              this.hideModal();
            }
          });

          this.fetchBooking(this.state.booking.id);
          this.fetchBookingTeams();
          this.fetchEventAdditionalPriceDefinitions();
          this.handleChangeCurrentBookingMember(new BookingMember());

          const requiredFields = {
            ...Object.keys(this.state.bookingMemberRequiredFieldsValid).reduce(
              (reduced, key) => ({ ...reduced, [key]: true }),
              {}
            ),
          };

          this.setState({
            bookingMemberRequiredFieldsValid: requiredFields,
            selectedOptions: [],
          });
        })
        .catch((resp) => {
          this.showError(resp);
        });
    } else if (this.state.modeMember === AddBooking.EditMode) {
      RestUtilities.put<BookingMember>(
        "/api/BookingMembers/Edit",
        bookingMember
      )
        .then((resp) => {
          this.fetchBookingMembers();
          this.fetchBooking(this.state.booking.id);
          this.fetchBookingTeams();
          this.handleChangeCurrentBookingMember(new BookingMember());
          this.fetchEventAdditionalPriceDefinitions();
          this.hideModal();

          const requiredFields = {
            ...Object.keys(this.state.bookingMemberRequiredFieldsValid).reduce(
              (reduced, key) => ({ ...reduced, [key]: true }),
              {}
            ),
          };

          this.setState({ bookingMemberRequiredFieldsValid: requiredFields });
        })
        .catch((resp) => {
          this.showError(resp);
        });
    }
  };

  submitNewTeam = (): void => {
    const newTeam = { ...this.state.newTeam };
    newTeam.bookingId = this.state.booking.id;

    if (this.state.modeTeam === "Submit") {
      RestUtilities.post<BookingTeams>("/api/BookingTeams/Submit", newTeam)
        .then((resp) => {
          this.fetchBooking(this.state.booking.id);
          this.fetchBookingTeams().then(() => {
            this.setState(
              {
                showAddTeamModal: false,
              },
              () => this.showAddTeamBookingMemberModal(new BookingMember())
            );
          });
        })
        .catch((resp) => {
          this.showError(resp);
        });
    } else if (this.state.modeTeam === "Edit") {
      RestUtilities.put<BookingTeams>("/api/BookingTeams/Edit", newTeam)
        .then((resp) => {
          this.fetchBookingTeams();
          this.hideModal();
        })
        .catch((resp) => {
          this.showError(resp);
        });
    }
  };

  deleteTeam = (id: number) => {
    const url = `/api/BookingTeams/Delete?id=${id}`;

    RestUtilities.delete(url)
      .then((resp) => {
        this.fetchBookingTeams();
        this.fetchBooking(this.state.booking.id);

      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  deleteBookingMember = (id: number): void => {
    RestUtilities.delete(`/api/BookingMembers/Delete?id=${id}`)
      .then((resp) => {
        this.fetchBookingMembers();
        this.fetchBooking(this.state.booking.id);
        this.fetchBookingTeams();
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  validateBookingMember = (bookingMember: BookingMember): boolean => {
    let requiredFields: any = {};
    if (this.state.showAddTeamBookingMemberModal) {
      requiredFields = {
        ...this.state.bookingMemberRequiredFieldsValid,
        teamId: true,
      };
    } else {
      const { teamId, ...rest } = this.state.bookingMemberRequiredFieldsValid;
      requiredFields = rest;
    }
    let valid: boolean = true;

    Object.keys(requiredFields).map((x) => {
      if (
        bookingMember[x] === null ||
        bookingMember[x] === undefined ||
        bookingMember[x] === ""
      ) {
        valid = false;
        requiredFields[x] = false;
      } else {
        requiredFields[x] = true;
      }
    });

    let optionTypes = (
      this.state.options as EventAdditionalPriceDefinitions[]
    ).map((x) => {
      return x.eventAdditionalPriceTypeId;
    });
    optionTypes = [...new Set(optionTypes)];

    valid =
      valid &&
      optionTypes.every((x) => {
        const isSelected =
          this.state.selectedOptions.filter(
            (y) => y.eventAdditionalPriceTypeId === x
          ).length > 0;
        return isSelected;
      });

    this.setState({ bookingMemberRequiredFieldsValid: requiredFields });
    return valid;
  };

  showError = (resp: any): void => {
    if (typeof resp.error_content != "undefined" && resp.error_content) {
      this.setState({ showError: true, errorMessage: resp.error_content });
    }
  };

  handleSnackbarClose = (event: any, reason: string) => {
    if (reason === "clickaway") return;

    this.setState({ showError: false });
  };

  resetSelectedOptions = () => {
    this.setState({ selectedOptions: [] });
  };

  // Edit user modal handlers
  handleHideEditUserModal = () => {
    this.setState({ showEditUserModal: false });
  };

  handleShowEditUserModal = () => {
    this.setState({ showEditUserModal: true });
  };

  editUser = () => {
    RestUtilities.put<Users>("/api/Users/Edit", this.state.userToEdit)
      .then((resp) => {
        this.setState({ showEditUserModal: false });
        let event = { target: { value: this.state.userToEdit.personalNr } };
        this.handleChangeResponsiblePerson(event);
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  handleEditChange = (event: any) => {
    const newModel = { ...this.state.userToEdit } as Users;

    newModel[event.target.name] = event.target.value;
    this.setState({ userToEdit: newModel });
  };

  componentDidMount() {
    this.fetchPersonalNumbers(null);
    this.fetchUserRoles();
    this.fetchUserGroups();
    this.checkIsSingleAvailable();
    this.checkIsTeamAvailable();
    this.checkIsTeamPlayerAvailable();
  }

  componentDidUpdate(prevProps: any) {
    if (
      this.props.router.location.search !== prevProps.router.location.search &&
      this.props.router.location.search !== ""
    ) {
      const params = new URLSearchParams(this.props.router.location.search);
      const value = params.get("eventid");

      this.eventId = parseInt(value);
    } else if (
      this.props.router.location.search !== prevProps.router.location.search &&
      this.props.router.location.search === ""
    ) {
      this.eventId = null;
    }
  }

  public render() {
    const { activeStep } = this.state;
    const steps: any[] = this.getSteps();

    return (
      <>
        <h2 className="mt-3 title">{`Anmeldung für ${this.state.event.eventName}`}</h2>
        <Stepper alternativeLabel nonLinear activeStep={activeStep}>
          {steps.map((label, index) => {
            return (
              <Step key={label}>
                <StepButton>{label}</StepButton>
              </Step>
            );
          })}
        </Stepper>
        <div className="row mb-4 saveButton">
          <div>
            {activeStep !== 0 && activeStep <= steps.length - 1 && (
              <Button
                onClick={this.handleBack}
                color="secondary"
                className="mr-2 btnBlue"
              >
                Zurück
              </Button>
            )}
            {activeStep <= steps.length - 1 && (
              <Button
                className="btnBlue"
                variant="contained"
                color="primary"
                onClick={this.handleNext}
              >
                {activeStep === steps.length - 1
                  ? "Speichern & Abschließen"
                  : "Speichern & Weiter"}
              </Button>
            )}
          </div>
        </div>
        <div>{this.getStepContent(activeStep)}</div>
        <GrowMessage
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          message={this.state.errorMessage}
          visible={this.state.showError}
          autoHideDuration={6000}
          onClose={this.handleSnackbarClose}
        ></GrowMessage>
      </>
    );
  }
}

export default withRouter(AddBooking);
